<template>
  <div>
    <!-- begin: Single Modal -->
    <router-view :key="$route.path" />
    <!-- end: Single Modal -->
    <div class="row" v-show="this.$route.fullPath == '/Jobs'">
      <div class="col-xl-12">
        <div
          class="kt-portlet kt-portlet--last kt-portlet--head-lg kt-portlet--responsive-mobile"
        >
          <div class="kt-portlet__head kt-portlet__head--lg">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="kt-font-brand flaticon2-shield"></i>
              </span>
              <h3 class="kt-portlet__head-title">ใบงาน</h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <!-- begin: Search Form -->
            <form
              autocomplete="off"
              class="kt-form"
              @submit="formSubmit"
              ref="searchForm"
            >
                <div class="row">
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>ค้นหาเลขที่ใบงาน:</label>
                            <input v-model="jobNumber"
                                   type="text"
                                   class="form-control"
                                   placeholder="ค้นหาจาก เลขที่ใบงาน" />
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>ประเภทใบงาน:</label>
                            <treeselect v-model="jobTypeCode"
                                        :multiple="true"
                                        :options="jobTypeCodeOptions"
                                        :clear-on-select="true"
                                        placeholder="กรุณาเลือก" />
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>สถานะ:</label>
                            <treeselect v-model="jobStatusCode"
                                        :multiple="true"
                                        :options="jobStatusCodeOptions"
                                        :clear-on-select="true"
                                        placeholder="กรุณาเลือก" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>คำค้นหา:</label>
                            <input v-model="keyword"
                                   type="text"
                                   class="form-control"
                                   placeholder="ค้นหาจาก สถานที่ต้นทาง/ปลายทาง" />
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>ประเภทสินค้า:</label>
                            <treeselect v-model="productTypeId"
                                        :multiple="true"
                                        :options="productTypeIdOptions"
                                        :clear-on-select="true"
                                        placeholder="กรุณาเลือก" />
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>ชื่อสินค้า:</label>
                            <treeselect v-model="assetCode"
                                        :multiple="true"
                                        :options="assetCodeOptions"
                                        :clear-on-select="true"
                                        placeholder="กรุณาเลือก" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>สถานที่ต้นทาง (Origin):</label>
                            <treeselect v-model="originLocationId"
                                        :multiple="true"
                                        :load-options="LoadoriginLocationIdOptions"
                                        :async="true"
                                        v-on:select="ClearAfterselect"
                                        searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                        placeholder="เลือกสถานที่ต้นทาง (Origin) ที่ต้องการค้นหา"
                                        :cacheOptions="false" />
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label>สถานที่ปลายทาง (Destination):</label>
                            <treeselect v-model="destinationLocationId"
                                        :multiple="true"
                                        :load-options="LoaddestinationLocationIdOptions"
                                        :async="true"
                                        v-on:select="ClearAfterselect"
                                        searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                        placeholder="เลือกสถานที่ปลายทาง (Destination) ที่ต้องการค้นหา"
                                        :cacheOptions="false" />
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <div class="form-group">
                            <label class="label">ผู้ดำเนินการ:</label>
                            <treeselect v-model="jobUsersId"
                                        :multiple="true"
                                        :load-options="LoadjobUsersIdOptions"
                                        :async="true"
                                        v-on:open="reLoadjobUsersIdOptions"
                                        v-on:select="ClearAfterselect"
                                        placeholder="กรุณาเลือก"
                                        :cacheOptions="true"
                                        ref="jobUsersId" />
                        </div>
                    </div>
                </div>

              <div class="row">
                <div class="col-xl-4">
                  <div class="form-group ">
                    <label class="label">วันที่(เริ่มต้น):</label>
                    <div class="input-group date">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="(วว/ดด/ปปปป)"
                        id="jobsDateStart"
                        name="jobsDateStart"
                        ref="jobsDateStart"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="la la-calendar-check-o"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="form-group">
                    <label class="label">วันที่(สิ้นสุด):</label>
                    <div class="input-group date">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="(วว/ดด/ปปปป)"
                        id="jobsDateEnd"
                        name="jobsDateEnd"
                        ref="jobsDateEnd"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="la la-calendar-check-o"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                

              </div>

              <div class="row mb-3">
                <div class="col-xl-12">
                  <button type="submit" class="btn btn-primary">ค้นหา</button>
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="formReset"
                  >
                    ล้างข้อมูล
                  </button>
                </div>
              </div>
            </form>
            <!-- end: Search Form -->

            <!--begin: Datatable -->
            <table
              class="table-sm table-striped table-bordered table-hover"
              id="jobTable"
              ref="jobTable"
            >
              <thead>
                <tr>
                  <th class="all">เลขที่ใบงาน</th>
                  <th class="all">ประเภท</th>
                  <th class="all">ต้นทาง</th>
                  <th class="all">ปลายทาง</th>
                  <th class="all">สถานะ</th>
                  <th class="all">จำนวนบาร์โค้ด</th>
                  <th class="not-mobile">วันที่เคลื่อนไหวล่าสุด</th>
                  <th class="not-mobile">ดำเนินการโดย</th>
                  <th class="none">ใช้งานแบบ Offline โดย</th>
                  <th class="none">หมายเหตุ</th>
                  <th class="all">คำสั่ง</th>
                </tr>
              </thead>
            </table>
            <!--end: Datatable -->
          </div>
        </div>
      </div>
    </div>

    <barcode-form ref="barcodeForm"></barcode-form>
    <spare-product-list ref="spareProductList"></spare-product-list>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import barcodeForm from "./JobImportBarcodeForm";
import spareProductList from "./JobAddSpareProductList";

// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

// CR-Job-Stock: route helper — write-off jobs use dedicated route
function getJobEditPath(data) {
  if (data && data.jobTypeCode === "JOB_TYPE_WRITE_OFF_STOCK") {
    return "/Jobs/WriteOffStock/Edit/" + data.jobId;
  }
  return "/Jobs/Edit/" + data.jobId;
}
function getJobViewPath(data) {
  if (data && data.jobTypeCode === "JOB_TYPE_WRITE_OFF_STOCK") {
    return "/Jobs/WriteOffStock/View/" + data.jobId;
  }
  // existing jobs use /Jobs/Edit/:id even when not editable (read-only handled inside JobForm)
  return "/Jobs/Edit/" + data.jobId;
}

let JobActions = Vue.extend({
  template: `
  <div>

    <a v-if="!data.isEditable && (data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' || $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))" :href="getViewUrl(data)" @click.prevent="view" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ดูข้อมูลใบงาน">
      <i class="fa fa-search"></i>
    </a>

    <a v-if="data.isDeletable && data.jobTypeCode != 'JOB_TYPE_AUDIT_STOCK'" href="#" @click.prevent="setValidate" class="btn btn-sm btn-clean btn-icon btn-icon-md"
      :title="!data.isNoValidate ? 'เปิดใช้งานตรวจสอบบาร์โค้ด' : 'ปิดใช้งานตรวจสอบบาร์โค้ด'">
      <i class="fa" :class="{ 'fa-lock kt-font-success': !data.isNoValidate, 'fa-unlock kt-font-danger': data.isNoValidate }"></i>
    </a>

    <a v-if="data.isOffline" href="#" @click.prevent="upload" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="อัพโหลดไฟล์ Export จาก Handheld">
      <i class="fa fa-upload kt-font-dark"></i>
    </a>

    <a v-if="(data.isOfflineAdminBeerClaim && data.jobTypeCode != 'JOB_TYPE_DESTROY' && data.jobTypeCode != 'JOB_TYPE_PICKUP' && data.jobTypeCode != 'JOB_TYPE_REPAIR' && data.jobTypeCode != 'JOB_TYPE_HOLD_CHECKER' && data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' && (data.isOffline || data.jobStatusCode == 'JOB_STATUS_PENDING' || data.jobStatusCode == 'JOB_STATUS_WAITING')) || (data.jobTypeCode == 'JOB_TYPE_DESTROY' && data.jobStatusCode == 'JOB_STATUS_REQUEST_APPROVAL') || (data.jobTypeCode == 'JOB_TYPE_PICKUP' && data.jobStatusCode == 'JOB_STATUS_PICKUP')" href="#" @click.prevent="commit" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ปิดใบงาน">
      <i class="fa fa-archive kt-font-primary"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_WRITE_OFF_STOCK' && data.jobStatusCode == 'JOB_STATUS_PENDING' && $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT'])" href="#" @click.prevent="closeWriteOff(data)" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ปิดใบงาน">
      <i class="fa fa-archive kt-font-primary"></i>
    </a>

    <a v-if="data.isOffline && $root.canShow(['super_admin']) && data.jobTypeCode != 'JOB_TYPE_PICKUP' && data.jobTypeCode != 'JOB_TYPE_REPAIR' && data.jobTypeCode != 'JOB_TYPE_HOLD_CHECKER'" href="#" @click.prevent="goOnline" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="เปิดใช้งานแบบ Online">
      <i class="fa fa-toggle-on kt-font-success"></i>
    </a>

    <a v-if="data.isEditable && (data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' || $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))" :href="getEditUrl(data)" @click.prevent="edit" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูลใบงาน">
      <i class="fa fa-edit kt-font-warning"></i>
    </a>

    <a v-if="data.isDeletableRetrive && (data.jobTypeCode != 'JOB_TYPE_WRITE_OFF_STOCK' || $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT']))" href="#" @click.prevent="remove" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ยกเลิกใบงาน">
      <i class="fa fa-trash-alt kt-font-danger"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_RETURN_ADHOC' && data.originLocationType == 'PLANT' && data.jobStatusCode == 'JOB_STATUS_CN_APPROVAL'" :href="'/Jobs/EditCN/' + data.jobId" @click.prevent="editCN" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขรายการ CN">
      <i class="fa fa-file-invoice" style="color: #800080"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_RETURN_ADHOC' && data.originLocationType == 'PLANT' && (data.jobStatusCode == 'JOB_STATUS_CN_APPROVAL' || data.jobStatusCode == 'JOB_STATUS_SUCCESS')" :href="'/Print/CNForm/' + data.jobId" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="พิมพ์ใบ CN">
      <i class="fa fa-print" style="color: #800080"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_EXCHANGE' && data.jobStatusCode == 'JOB_STATUS_SUCCESS'" :href="'/Print/ExchanceForm/' + data.jobId" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="พิมพ์ใบโอนสินค้า">
      <i class="fa fa-print" style="color: #800080"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_WRITE_OFF_STOCK' && data.jobStatusCode == 'JOB_STATUS_SUCCESS' && $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT', 'JOB_ADMIN_WRITE_OFF_STOCK_AGENT', 'JOB_ADMIN_WRITE_OFF_STOCK_SUB_AGENT'])" :href="'/Print/WriteOffForm/' + data.jobId" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="พิมพ์ใบงาน">
      <i class="fa fa-print" style="color: #800080"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_WRITE_OFF_STOCK' && data.jobStatusCode == 'JOB_STATUS_SUCCESS' && $root.canShow(['super_admin', 'JOB_ADMIN_WRITE_OFF_STOCK_PLANT'])" href="#" @click.prevent="exportWriteOffExcel(data)" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="Export Excel">
      <i class="fa fa-file-excel" style="color: #28a745"></i>
    </a>

    <a v-if="data.jobTypeCode == 'JOB_TYPE_RETURN_SUPPLIER' && data.canAssignSpareParts" href="#" @click.prevent="spareConfig(data)"
    class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ระบุอะไหล่ซัพพลายเออร์">
      <i class="fa fa-list-alt" 
        :style="{ color: data.isSpareAdded ? '#28a745' : '#fd397a', borderRadius: '3px' }"></i>
    </a>
  </div>`,
  methods: {
    upload: function() {
      this.$parent.$refs.barcodeForm.job = this.data;
      $(this.$parent.$refs.barcodeForm.$el).modal("show");
    },
    spareConfig(jobData) {
    
      this.$parent.$refs.spareProductList.job = jobData;
      this.$parent.$refs.spareProductList.showModal(jobData);

      //$(this.$parent.$refs.spareProductList.$el).modal("show");
      // ดึง DOM element ที่แท้จริงจาก ref โดยไม่อ้างผ่าน $el
      const modalEl = this.$parent.$refs.spareProductList.$refs.spareProductList;
        //$(modalEl).modal("show");

        $(modalEl).modal({
    backdrop: 'static',
    keyboard: false
  });
    },

    setValidate: function() {
      if (!this.$root.canShow(["super_admin"])) {
        Swal.fire({
          title: "ไม่มีสิทธิ์",
          type: "warning",
          html:
            "คุณไม่มีสิทธิ์ เปิด/ปิดการตรวจสอบสถานะบาร์โค้ดของใบงาน <strong>" +
            this.data.jobNumber +
            "</strong> กรุณาแจ้งผู้ดูแลระบบให้ดำเนินการ",
        });
        return;
      }

      let self = this;

      if (!this.data.isNoValidate) {
        Swal.fire({
          title: "คำสั่งปิดการตรวจสอบสถานะบาร์โค้ด",
          type: "warning",
          html:
            "กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะบาร์โค้ดของใบงาน <strong>" +
            this.data.jobNumber +
            "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            self.doSetValidate();
          }
        });
      } else {
        self.doSetValidate();
      }
    },
    doSetValidate: function() {
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/SetValidate", {
          jobId: this.data.jobId,
          isNoValidate: !this.data.isNoValidate,
        })
        .then(function(response) {
          if (response.data.status) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", response.data.message, "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    editCN: function() {
      router.push({ path: `/Jobs/EditCN/${this.data.jobId}` });
    },
    // CR-Job-Stock: helpers used by template — write-off jobs use dedicated route
    getEditUrl: function(data) {
      return getJobEditPath(data);
    },
    getViewUrl: function(data) {
      return getJobViewPath(data);
    },
    edit: function() {
      router.push({ path: getJobEditPath(this.data) });
    },
    view: function() {
      router.push({ path: getJobViewPath(this.data) });
    },
    handlerEdit: function(e) {
      document.getElementById(
        this.data.jobId
      ).href = getJobEditPath(this.data);
    },
    remove: function() {
      let self = this;

      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลใบงาน",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งยกเลิกข้อมูลใบงาน <strong>" +
          this.data.jobNumber +
          "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังยกเลิกข้อมูล กรุณารอสักครู่...",
          });

          axios
            .post("/Api/Jobs/Delete", {
              jobId: this.data.jobId,
            })
            .then(function(response) {
              if (response.data.status) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    goOnline: function() {
      let self = this;

      Swal.fire({
        title: "คำสั่งเปิดใช้งานแบบ Online",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งเปิดใช้งานแบบ Online ใบงาน <strong>" +
          this.data.jobNumber +
          "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });

          axios
            .post("/Api/Jobs/Online", {
              jobId: this.data.jobId,
            })
            .then(function(response) {
              if (response.data.status) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    exportWriteOffExcel: function(data) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังสร้างไฟล์ กรุณารอสักครู่...",
      });
      axios
        .get("/Api/WriteOffStockJobs/" + data.jobId + "/ExportExcel", {
          responseType: "blob",
        })
        .then(function(response) {
          var cd = response.headers["content-disposition"] || "";
          var match = cd.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
          var filename = match
            ? decodeURIComponent(match[1].replace(/^"|"$/g, ""))
            : "WriteOff.xlsx";
          var blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch(function(err) {
          Swal.fire("เกิดข้อผิดพลาด", "Export ไม่สำเร็จ", "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    closeWriteOff: function(data) {
      let self = this;
      Swal.fire({
        title: "คำสั่งปิดใบงาน",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งปิดใบงาน <strong>" +
          data.jobNumber +
          "</strong>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
          });
          axios
            .post("/Api/WriteOffStockJobs/" + data.jobId + "/Close", {})
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success");
                self.$parent.reloadDataTable();
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire(
                "เกิดข้อผิดพลาด",
                error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : "ไม่สามารถปิดใบงานได้",
                "error"
              );
            })
            .then(function() {
              KTApp.unblockPage();
            });
        }
      });
    },
    commit: function() {
      let self = this;
      if (self.data.jobTypeCode == "JOB_TYPE_PICKUP") {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html:
            "การปิดใบงานประเภท <strong>" +
            this.data.jobTypeName +
            (!this.data.originNoSML
              ? "</strong> จะต้องสร้างบิลขายภายในระบบ SML เพื่อบันทึกปิดใบงานก่อน"
              : "</strong> กรอกข้อมูลลูกค้าเพื่อบันทึกปิดใบงานก่อน"),
          showCancelButton: true,
          confirmButtonText: !this.data.originNoSML
            ? "กรอกบิลขาย"
            : "กรอกข้อมูลลูกค้า",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            router.push({ path: `/Jobs/Edit/${self.data.jobId}` });
          }
        });
      } else if (self.data.jobTypeCode == "JOB_TYPE_DESTROY") {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html:
            "การปิดใบงานประเภท <strong>" +
            this.data.jobTypeName +
            "</strong> จะต้องพิมพ์ใบขออนุมัติทำลายสินค้าและอัพโหลด เพื่อบันทึกปิดใบงานก่อน",
          showCancelButton: true,
          confirmButtonText: "อัพโหลดใบขออนุมัติฯ",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            router.push({ path: `/Jobs/Edit/${self.data.jobId}` });
          }
        });
      } else if (
        self.data.evidenceRequired &&
        self.data.evidenceCanPickFromGallery
      ) {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html:
            "การปิดใบงานประเภท <strong>" +
            this.data.jobTypeName +
            "</strong> จะต้องอัพโหลดรูปภาพหลักฐาน เพื่อบันทึกปิดใบงานก่อน",
          showCancelButton: true,
          confirmButtonText: "อัพโหลดรูปภาพหลักฐาน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            router.push({ path: `/Jobs/Edit/${self.data.jobId}` });
          }
        });
      } else {
        Swal.fire({
          title: "คำสั่งปิดใบงาน",
          type: "warning",
          html:
            "กรุณายืนยันคำสั่งปิดใบงาน <strong>" +
            this.data.jobNumber +
            "</strong>",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            self.commitJob();
          }
        });
      }
    },
    commitJob: function(force = false) {
      var self = this;

      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      if ( self.data.isNoValidate && 
        (
          self.data.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" ||
          self.data.jobTypeCode ==  "JOB_TYPE_EXCHANGE" || (self.data.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" && (self.data.fromJobTypeName == "ส่งสินค้าไปยังตัวแทน ฯ" || self.data.fromJobTypeName ==  "โอนทรัพย์สิน"))
        )
      )
      {
        force = true;
      }

      axios
        .post("/Api/Jobs/Commit", {
          jobId: self.data.jobId,
          force: force,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success");
            self.$parent.reloadDataTable();
            $(self.$el).modal("hide");
          } else {
            let msg = response.data.message;
            if (response.data.errors) {
              let html = "";
              let foundBarcodeMessage = false;

              if (self.data.jobTypeCode == "JOB_TYPE_HOLD_CHECKER") {
                for (var key in response.data.errors) {
                  if (response.data.errors.hasOwnProperty(key)) {
                    var errors = response.data.errors[key];
                    var cnt = errors.length / 5;
                    for (let i = 0; i < cnt; i++) {
                      let err = errors[i * 5 + 1];
                      html += "<li>" + err + "</li>";
                    }
                  }
                }
              } else {
                for (var key in response.data.errors) {
                  if (response.data.errors.hasOwnProperty(key)) {
                    var err = response.data.errors[key];
                    html += "<li>" + err[1] + "</li>";
                  }
                }
              }

              if (html) {
                if (
                  self.data.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" ||
                  self.data.jobTypeCode == "JOB_TYPE_EXCHANGE" ||
                  (self.data.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" &&
                    (self.data.fromJobTypeName == "ส่งสินค้าไปยังตัวแทน ฯ" || 
                    self.data.fromJobTypeName == "โอนทรัพย์สิน"))
                ) {

                  for (var key in response.data.errors) {
                    if (response.data.errors.hasOwnProperty(key)) {
                      var errors = response.data.errors[key];
                      for (let error of errors) {
                        if (error.includes("จำนวนบาร์โค้ดของ")) {
                          foundBarcodeMessage = true;
                          break;
                        }
                      }
                      if (foundBarcodeMessage) break;
                    }
                  }
                  if (foundBarcodeMessage) {
                    msg +=
                    "<div class='text-left mt-3'>กรุณาสแกนบาร์โค้ดให้ครบก่อนค่ะ<br /><br />สาเหตุ: <ul>" +
                    html +
                    "</ul></div>";
                  } else {
                    msg +=
                    "<div class='text-left mt-3'>ข้อมูลบาร์โค้ดไม่ถูกต้องกรุณาตรวจสอบใหม่อีกครั้งค่ะ<br /><br />สาเหตุ: <ul>" +
                    html +
                    "</ul></div>";
                  }
                }
                else{
                  msg +=
                    "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>" +
                    html +
                    "</ul></div>";
                }
                
              }
            }

            let start = msg.indexOf("||");
            let end = msg.lastIndexOf("||");
            if(start >= 0){
              let str = msg.substr((start+2), (end-start-2));
              let oldStr = msg.substr((start), (end-start+2));
              // console.log(start);
              // console.log(end);
              // console.log(str);
              // console.log(oldStr);
              let repl = "<strong class='text-danger'>"+str+"</strong>";
              msg = msg.replace(oldStr, repl);
            }

            if (
              self.data.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" ||
              self.data.jobTypeCode == "JOB_TYPE_EXCHANGE" ||
              (self.data.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" &&
                (self.data.fromJobTypeName == "ส่งสินค้าไปยังตัวแทน ฯ" || 
                self.data.fromJobTypeName == "โอนทรัพย์สิน"))
            ) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                html: msg,
                type: "error",
                confirmButtonText: "OK",
              });
            } else {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                html: msg,
                type: "error",
                showCancelButton: true,
                confirmButtonText:
                  "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
                cancelButtonText: "ตรวจสอบข้อมูล",
              }).then((result) => {
                if (result.value) {
                  self.commitJob(true);
                }
              });
            }
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      // -- End Commit Job
    },
  },
});

export default {
  components: {
    select2,
    barcodeForm,
    Treeselect,
    spareProductList,
  },
  data: function() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      jobUsersId: [],
      // jobStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "เลือกสถานะใบงานที่ต้องการค้นหา",
      //   multiple: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=JOB_STATUS",
      //     delay: 300,
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      jobStatusCodeOptions: [],
      // jobTypeCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "เลือกประเภทใบงานที่ต้องการค้นหา",
      //   multiple: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Jobs/JobType/Options",
      //     delay: 300,
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      jobTypeCodeOptions: [],
      originLocationIdOptions: [],
      // originLocationIdOptions: {
      //   placeholder: "เลือกสถานที่ต้นทาง (Origin) ที่ต้องการค้นหา",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Jobs/Origin/Options",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     if (!data.id || !data.data) return data.text;

      //     if (data.data.locationType == "PLANT") {
      //       return data.text;
      //     } else if (data.data.locationType == "AGENT") {
      //       var $container = $(
      //         "<div class='select2-result-repository clearfix'>" +
      //           "<div class='select2-result-repository__meta'>" +
      //           "<div class='select2-result-repository__title'></div>" +
      //           "<div class='select2-result-repository__description'></div>" +
      //           "</div>" +
      //           "</div>"
      //       );

      //       $container
      //         .find(".select2-result-repository__title")
      //         .text(data.text);

      //       if (data.data.agentType != "HEAD_OFFICE") {
      //         $container
      //           .find(".select2-result-repository__description")
      //           .text(
      //             "SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice
      //           );
      //       } else {
      //         $container
      //           .find(".select2-result-repository__description")
      //           .text("SAP Code: " + data.id + " สำนักงานใหญ่");
      //       }

      //       return $container;
      //     } else {
      //       return data.text;
      //     }
      //   },
      // },
      // originLocationIdOptions:[],
      destinationLocationIdOptions: {
        placeholder: "เลือกสถานที่ปลายทาง (Destination) ที่ต้องการค้นหา",
        allowClear: true,
        ajax: {
          url: "/Api/Jobs/Destination/Options",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          if (!data.id || !data.data) return data.text;

          if (data.data.locationType == "PLANT") {
            return data.text;
          } else if (data.data.locationType == "AGENT") {
            var $container = $(
              "<div class='select2-result-repository clearfix'>" +
                "<div class='select2-result-repository__meta'>" +
                "<div class='select2-result-repository__title'></div>" +
                "<div class='select2-result-repository__description'></div>" +
                "</div>" +
                "</div>"
            );

            $container
              .find(".select2-result-repository__title")
              .text(data.text);

            if (data.data.agentType != "HEAD_OFFICE") {
              $container
                .find(".select2-result-repository__description")
                .text(
                  "SAP Code: " + data.id + "<br />HQ: " + data.data.headOffice
                );
            } else {
              $container
                .find(".select2-result-repository__description")
                .text("SAP Code: " + data.id + " สำนักงานใหญ่");
            }

            return $container;
          } else {
            return data.text;
          }
        },
      },
      // destinationLocationIdOptions:[],
      keyword: "",
      jobNumber: "",
      jobStatusCode: [],
      jobTypeCode: [],
      originLocationId: [],
      destinationLocationId: [],
      productTypeId: [],
      productTypeIdOptions: [],
      assetCode: [],
      assetCodeOptions: [],
      canAssignSpareParts:false,
    };
  },
  methods: {
    LoadjobStatusCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=JOB_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.jobStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadjobTypeCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Jobs/JobType/Options", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.jobTypeCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadoriginLocationIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.originLocationIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Jobs/Origin/Options", {
            page: 1,
            all: true,
            search: searchQuery,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.originLocationIdOptions = [];
              data.forEach((element) => {
                self.originLocationIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.originLocationIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoaddestinationLocationIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.destinationLocationIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Jobs/Destination/Options", {
            page: 1,
            search: searchQuery,
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.destinationLocationIdOptions = [];
              data.forEach((element) => {
                self.destinationLocationIdOptions.push({
                  id: element.id,
                  label: element.text,
                  search: searchQuery,
                });
              });
            }
            callback(null, self.destinationLocationIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadjobUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Jobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
    reLoadjobUsersIdOptions: function(){
      this.$refs.jobUsersId.trigger.searchQuery = null;
    },
    LoadProductTypeIdOptions: function (e) {
        var self = this;
        axios
            .get("/Api/ProductType/Select2ProductType", {
                params: {
                    page: 1,
                    all: true,
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach((element) => {
                        self.productTypeIdOptions.push({
                            id: element.id,
                            label: element.text,
                        });
                    });
                }
            })
            .catch(function (error) { });
    },
    LoadAssetCodeOptions: function (e) {
        var self = this;
        axios
            .get("/Api/Product/Select2Product", {
                params: {
                    page: 1,
                    all: true,
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    var data = response.data.results;
                    data.forEach((element) => {
                        self.assetCodeOptions.push({
                            id: element.id,
                            label: element.text,
                        });
                    });
                }
            })
            .catch(function (error) { });
    },
    formReset: function (e) {

      this.keyword = "";
      this.jobNumber = "";
      this.jobStatusCode = [
        "JOB_STATUS_WAITING",
        "JOB_STATUS_PENDING",
        "JOB_STATUS_PICKUP",
        "JOB_STATUS_REQUEST_APPROVAL",
        "JOB_STATUS_CN_APPROVAL",
        "JOB_STATUS_SUCCESS",
      ];
      //this.$refs.jobTypeCode.setSelectedData([]);
      // this.$refs.originLocationId.setSelectedData([]);
      // this.$refs.destinationLocationId.setSelectedData([]);
      this.jobTypeCode = [];
      this.originLocationId = [];
      this.destinationLocationId = [];
    
      this.jobsDateStart = null;
      this.jobsDateEnd = null;

      this.jobUsersId = [];
      this.productTypeId = [];
      this.assetCode = [];

      $(`#jobsDateStart`).val("").trigger("change");
      $(`#jobsDateEnd`).val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $(this.$refs.jobTable).DataTable();
      table.search(this.keyword);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $(this.$refs.jobTable)
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    CheckRoleAdminBeerClaim: function(){
      let self = this;
      let status = true;
      if(typeof self.$root.user.profile.role == "object"){
        const result = self.$root.user.profile.role.filter(word => word == "ADMIN_BEER_CLAIM");
        if(result.length > 0){
          status = false;
        }else{
          status = true;
        }
      }else if(typeof self.$root.user.profile.role == "string"){
        if(self.$root.user.profile.role == "ADMIN_BEER_CLAIM"){
          status = false;
        }else{
          status = true;
        }
      }else{
        status = true;
      }
      return status;
    }
  },
  beforeRouteUpdate(to, from, next) {
    // console.log(from);
    next();
    if (
      from &&
      (from.name == "JobEdit" ||
        from.path.toLowerCase().startsWith("/jobs/create"))
    ) {
      this.$nextTick(function() {
        this.reloadDataTable();
      });
    }
  },
  async mounted() {
    let self = this;
    self.jobStatusCode = [
      "JOB_STATUS_WAITING",
      "JOB_STATUS_PENDING",
      "JOB_STATUS_PICKUP",
      "JOB_STATUS_REQUEST_APPROVAL",
      "JOB_STATUS_CN_APPROVAL",
      "JOB_STATUS_SUCCESS",
      // { id: "JOB_STATUS_WAITING", label: "รอดำเนินการ" },
      // { id: "JOB_STATUS_PENDING", label: "ระหว่างดำเนินการ" },
      // { id: "JOB_STATUS_PICKUP", label: "ระหว่างเร่ขาย" },
      // { id: "JOB_STATUS_REQUEST_APPROVAL", label: "รอการอนุมัติ" },
      // { id: "JOB_STATUS_CN_APPROVAL", label: "รอตรวจสอบ CN" },
      // { id: "JOB_STATUS_SUCCESS", label: "ดำเนินการเรียบร้อย" },
    ];
    self.LoadjobStatusCodeOptions();
    self.LoadjobTypeCodeOptions();
    // self.LoadoriginLocationIdOptions();
    // self.LoaddestinationLocationIdOptions();
    self.LoadProductTypeIdOptions();
    self.LoadAssetCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    $(self.$refs.jobsDateStart)
      .datepicker(
        "update",
        !!self.jobsDateStart ? self.jobsDateStart.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    $(self.$refs.jobsDateEnd)
      .datepicker(
        "update",
        !!self.jobsDateStart ? self.jobsDateEnd.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    // begin first table
    $.fn.dataTable.ext.errMode = 'none';
    var table = $(self.$refs.jobTable);
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,

        ajax: {
          url: "/Api/Jobs/Find",
          type: "post",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            d.jobNumber = self.jobNumber;
            d.jobStatusCode = self.jobStatusCode;
            d.jobTypeCode = self.jobTypeCode;
            d.originLocationId = self.originLocationId;
            d.destinationLocationId = self.destinationLocationId;
            d.jobsDateStart = self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null;
            d.jobsDateEnd = self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null;
            d.jobUsersId = self.jobUsersId;
            d.productTypeId = self.productTypeId;
            d.assetCode = self.assetCode;
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
            <'row'<'col-sm-12'tr>>
    	<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "desc"]],

        columns: [
          {
            data: "jobRunning",
            width: "10%",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.isOffline) {
                return (
                  '<i class="fa fa-genderless kt-font-danger"></i> ' +
                  full.jobNumber
                );
              } else {
                return (
                  '<i class="fa fa-genderless kt-font-success"></i> ' +
                  full.jobNumber
                );
              }
            },
          },
          {
            data: "jobTypeName",
            width: "10%",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.jobTypeCode == "JOB_TYPE_PRODUCE") {
                return (
                  data +
                  "<br /><span class='text-info'><strong><i class='fa fa-question-circle'></i> " +
                  full.finishedProductCode +
                  "</strong><br />" +
                  full.finishedProductName +
                  "</span>"
                );
              } else {
                return data;
              }
            },
          },
          {
            data: "originName",
            width: "20%",
            className: "text-center", 
            render: function(data, type, full, meta) {
              var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>"+data+"</pre>";
 
              if (full.fromJobNumber) {
                html +=
                  "<br /><span class='text-info'><strong><i class='fa fa-question-circle'></i> " +
                  full.fromJobNumber +
                  "</strong><br />" +
                  full.fromJobTypeName +
                  "</span>";
              }

              if (full.productLoanHeaderId) {
                if (
                  full.jobTypeCode == "JOB_TYPE_RETRIEVE_ITEM" &&
                  full.destinationLocationType == "PLANT"
                ) {
                  html +=
                    "<br /><span class='text-warning'><strong><i class='fa fa-question-circle'></i> " +
                    full.productLoanRequestDocNo +
                    "</strong><br />รับคืนจากการยืม</span>";
                } else {
                  html +=
                    "<br /><span class='text-warning'><strong><i class='fa fa-question-circle'></i> " +
                    full.productLoanRequestDocNo +
                    "</strong></span>";
                }
              }

              if (full.claimId) {
                html +=
                  "<br /><span class='text-danger'><strong><i class='fa fa-question-circle'></i> " +
                  full.claimNumber +
                  "</strong><br />เคลมเบียร์</span>";
              }

              return html;
            },
          },
          {
            data: "destinationName",
            width: "20%",
            className: "text-center",
            render: function(data, type, full, meta) {
              // TRANSFER_TO_MULTI_SHOP: แสดงรายชื่อปลายทางทั้งหมดจาก jobDestinations
              if (full.jobTypeCode == "JOB_TYPE_TRANSFER_TO_MULTI_SHOP") {
                if (full.jobDestinations && full.jobDestinations.length > 0) {
                  let html = '<div class="text-left">';
                  full.jobDestinations.forEach((dest, index) => {
                    let destText = '';
                    if (dest.shipToShop) {
                      // ปลายทางเป็น SHOP
                      destText = `[${dest.destinationShop.custCode || ''}] ${dest.destinationShop.customerName || ''} ${dest.destinationShop.name2 ? '(' + dest.destinationShop.name2 + ')' : ''}`;
                    } else if (dest.shipToShopSubAgent) {
                      // ปลายทางเป็น SUBSHOP
                      destText = `[${dest.destinationShopSubAgent.subAgentCode || ''}] ${dest.destinationShopSubAgent.subAgentName || ''} ${dest.destinationShopSubAgent.subAgentName2 ? '(' + dest.destinationShopSubAgent.subAgentName2 + ')' : ''}`;
                    }
                    html += `${index + 1}. ${destText}<br />`;
                  });
                  html += '</div>';
                  return html;
                }
                return data || '-';
              }
              
              // TRANSFER_TO_AGENT, TRANSFER_TO_SHOP: แสดง shipTos
              if (
                full.jobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT" ||
                full.jobTypeCode == "JOB_TYPE_TRANSFER_TO_SHOP"
              )
                return full.shipTos.length > 0 ? full.shipTos.join(", ") : data;
              
              // NEW_SHOP: แสดง data ปกติ
              if (full.jobTypeCode == "JOB_TYPE_NEW_SHOP") {
                return data;
              }
              
              // กรณีอื่นๆ: ถ้า destination = origin ไม่แสดง
              if (data == full.originName) return "";
              else return data;
            },
          },
          {
            data: "jobStatusName",
            width: "10%",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (
                full.jobTypeCode == "JOB_TYPE_DESTROY" &&
                full.jobStatusCode == "JOB_STATUS_SUCCESS"
              ) {
                return (
                  '<span class="text-success"><i class="fa fa-check-circle"></i> ' +
                  data +
                  "</span>" +
                  (full.approve
                    ? '<br /><span class="text-success">( อนุมัติ )</span>'
                    : '<br /><span class="text-danger">( ไม่อนุมัติ )</span>')
                );
              } else if (full.jobStatusCode == "JOB_STATUS_SUCCESS") {
                return (
                  '<span class="text-success"><i class="fa fa-check-circle"></i> ' +
                  data +
                  "</span>"
                );
              } else if (full.jobStatusCode == "JOB_STATUS_PENDING") {
                return (
                  '<span class="text-warning"><i class="fa fa-sync-alt"></i> ' +
                  data +
                  "</span>"
                );
              } else if (full.jobStatusCode == "JOB_STATUS_PICKUP") {
                return (
                  '<span class="text-warning"><i class="fa fa-truck-pickup"></i> ' +
                  data +
                  "</span>"
                );
              } else if (full.jobStatusCode == "JOB_STATUS_REQUEST_APPROVAL") {
                return (
                  '<span class="text-warning"><i class="fa fa-file-signature"></i> ' +
                  data +
                  "</span>"
                );
              } else if (full.jobStatusCode == "JOB_STATUS_CN_APPROVAL") {
                return (
                  '<span style="color: #800080"><i class="fa fa-exclamation-triangle"></i> ' +
                  data +
                  "</span>"
                );
              } else {
                return (
                  '<span class="text-danger"><i class="fa fa-ban"></i> ' +
                  data +
                  "</span>"
                );
              }
            },
          },
          {
            data: "totalCheckedQuantity",
            className: "text-center",
            width: "5%",
            render: function(data, type, full, meta) {
              
              // let total = full.totalCheckedQuantity + full.totalQuantityNoBarcode;
              // if (total > 0) {
              //   let str =
              //     self.$options.filters.currency(
              //       total,
              //       "",
              //       0
              //     ) +
              //     "/" +
              //     self.$options.filters.currency((full.totalQuantity + full.totalQuantityNoBarcode), "", 0);

              //   if (full.totalQuantity != full.totalCheckedQuantity) {
              //     return (
              //       "<span class='text-danger'><i class='fa fa-exclamation-circle'></i> " +
              //       str +
              //       "</span>"
              //     );
              //   } else {
              //     return str;
              //   }
              // } else {
              //   return self.$options.filters.currency(
              //     full.totalCheckedQuantity,
              //     "",
              //     0
              //   );
              // }

              if (full.totalQuantity > 0 ) {
                if(full.jobTypeCode == 'JOB_TYPE_AUDIT_STOCK'){ 
                  return self.$options.filters.currency(full.totalQuantity + full.totalQuantityNoBarcode, "", 0); 
                }
                let str =
                  self.$options.filters.currency(
                    full.totalCheckedQuantity + full.totalQuantityNoBarcode,
                    "",
                    0
                  ) +
                  "/" +
                  self.$options.filters.currency(full.totalQuantity + full.totalQuantityNoBarcode, "", 0);

                if (full.totalQuantity != full.totalCheckedQuantity) {
                  return (
                    "<span class='text-danger'><i class='fa fa-exclamation-circle'></i> " +
                    str +
                    "</span>"
                  );
                } else {
                  return str;
                }
              } else {
                return self.$options.filters.currency(
                  full.totalCheckedQuantity + full.totalQuantityNoBarcode,
                  "",
                  0
                );
              }
            },
            // render: function(data, type, full, meta) {
            //   //let total = full.totalCheckedQuantity + full.totalQuantityNoBarcode;
            //   let totalCheckedQuantity = full.totalCheckedQuantity;
            //   let totalQuantity = full.totalQuantity;
            //   let totalQuantityNoBarcode = full.totalQuantityNoBarcode;
              
            //   if (totalQuantity > 0) {
            //     let str = self.$options.filters.currency(totalQuantity, "", 0) + "/" + self.$options.filters.currency((full.totalQuantity + full.totalQuantityNoBarcode), "", 0);
            //     // let str = self.$options.filters.currency(totalCheckedQuantity, "", 0) + "/" + self.$options.filters.currency((totalQuantity + totalQuantityNoBarcode), "", 0);

            //     if (totalQuantity != totalCheckedQuantity) {
            //       return ("<span class='text-danger'><i class='fa fa-exclamation-circle'></i> " + str + "</span>");
            //     }
            //     else {
            //       return str;
            //     }
            //   }
            //   else {
            //     return self.$options.filters.currency(totalCheckedQuantity, "", 0);
            //   }
            // },
          },
          { data: "lastUpdateDate", width: "10%", className: "text-center" },
          { data: "lastUpdateUser", width: "10%", className: "text-center" },
          { data: "offlineBy" },
          { data: "remark" },
          {
            data: "jobId",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            // For ADMIN_BEER_CLAIM
            if(data.isDeletable == true){
              if(self.$root.canShow(['super_admin','MANAGE_MASTER','JOB_ADMIN_BORROW_APPROVE']) == true){
                data.isDeletable = true;
              }else{
                data.isDeletable = self.CheckRoleAdminBeerClaim();
              }
            }

            data.isDeletableRetrive = data.isDeletable

            if(self.$root.user.profile.profile_type == 'COMPANY_PROFILE_TYPE_BR'
              && self.$root.user.profile.plant != "" && self.$root.user.profile.plant !== null
              && (data.jobStatusCode == 'JOB_STATUS_WAITING' || data.jobStatusCode == 'JOB_STATUS_PENDING')
              && data.jobTypeCode == 'JOB_TYPE_RETRIEVE_ITEM' && (data.productLoanTypeName == 'รับคืนจากการยืม' || data.fromJobTypeName == 'ส่งสินค้า/ทรัพย์สินคืนต้นทาง')
            ){
              data.isDeletableRetrive = true;
            }

            if( data.jobStatusCode ==  "JOB_STATUS_CN_APPROVAL"  && 
                (
                  (self.$root.user.profile.profile_type == 'COMPANY_PROFILE_TYPE_BR' 
                  && self.$root.user.profile.plant != "" 
                  && self.$root.user.profile.plant !== null
                  ) || self.$root.canShow(['super_admin','MANAGE_MASTER']) == true
                ))
            {
               data.isDeletableRetrive = true;
            }

            if(data.isEditable == true){
              if(self.$root.canShow(['super_admin','MANAGE_MASTER','JOB_ADMIN_BORROW_APPROVE']) == true){
                data.isEditable = true;
              }else{
                data.isEditable = self.CheckRoleAdminBeerClaim();
              }
              }

              // For add supplier spare
              //if (data.isEditable == true) {
                  if (self.$root.canShow(['super_admin','OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN','JOB_ADMIN_RETURN_SUPPLIER']) == true) {
                      data.canAssignSpareParts = true;
                  } else {
                      data.canAssignSpareParts = false;
                  }
              //}


              

            data.isOfflineAdminBeerClaim = self.CheckRoleAdminBeerClaim(); // false คือปิด true คือเปิด
            // For ADMIN_BEER_CLAIM
            new JobActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="css">
.select2-container--default.select2-container--disabled
  .select2-selection--multiple,
.select2-container--default.select2-container--disabled
  .select2-selection--single {
  background: #fff;
  border-color: #ebedf2;
}
</style>


// WEBPACK FOOTER //
// App/Components/Job/JobList.vue